import { useCallback, useEffect, useState } from "react";
import { TicketService } from "../services/TicketService";

export const useHookTicketDetail = ({ticketID}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await TicketService.show({ticketID});
            console.log(res);
            setData(res.data.data);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [ticketID]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        loading,
        error,
        refreshData: getData,
    };
};